module.exports = __webpack_public_path__ + "media/newstyle/images/stars_sprint_orange-c98782cbfc1fbc02719e5f94dcb64a46.svg";